import styled from "styled-components";
import { motion } from "framer-motion";
import { Button } from "@atoms";

export const UploaderContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;
`;

export const FileInputLabel = styled(Button)`
  display: flex;
  
`;

export const HiddenFileInput = styled.input`
  display: none;
`;

export const InfoTextInput = styled.input`
  height: 28px;
  outline: none;
  align-self: center;
  text-align: center;
  width: 100%;
  padding: 4px;

  font-family: Inter, sans-serif;
  font-weight: 400;
  font-size: 16px;
  line-height: 120%;
  color: #89796E;
  background: none;
  border: none;
`;

export const InfoText = styled.p`
  font-family: Arial, sans-serif;
  font-size: 14px;
  color: #555;
  text-align: center;
`;

export const LabelWrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 24px;
`

export const CONTAINER_HEIGHT = 400;
export const GAP = 8; // gap in pixels (both vertical and horizontal)

export const FixedContainer = styled(motion.div)`
  gap: ${GAP}px;
  display: flex;
  flex-direction: column;
  box-sizing: border-box;
`;

export const RowContainer = styled(motion.div)`
  display: flex;
  width: 100%;
  gap: ${GAP}px;
  box-sizing: border-box;
`;

export const LightOverlay = styled.div`
  position: absolute;
  width: 100%;
  height: 100%;
  top: 0;
  left: 0;
  
  opacity: 0;
  transition: opacity 0.3s ease;
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 4;
  background: rgba(0, 0, 0, 0.05);
  cursor: pointer;
`;

export const Overlay = styled.div`
  position: absolute;
  width: 32px;
  height: 32px;
  padding: 8px;
  opacity: 0.8;
  border-radius: 4px;
  top: 8px;
  left: calc(100% - 40px);
  
  transition: opacity 0.3s ease;
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 4;
  background: rgba(0, 0, 0, 0.6);
  cursor: pointer;
`;

export const TrashIcon = styled.svg`
  width: 32px;
  height: 32px;
  fill: white;
  stroke: white;
`;

export const ImageWrapper = styled.div`
  display: flex;
  flex: 1;
  overflow: hidden;
  border-radius: 4px;
  position: relative;

  img {
    width: 100%;
    height: 100%;
    object-fit: cover;
    display: block;
    transition: transform 0.3s ease;
  }

  &:hover ${LightOverlay}, &:hover ${Overlay} {
    opacity: 1;
  }
`;
